import AsyncSelect from 'react-select/async';
import React, {useState, useEffect} from "react";
import {useOwners} from "../../../hooks";
import * as api from "../../../api/owners";

export function OwnersSelect({company, onChange, onBlur, value, isInvalid}) {
    const [typing, setTyping] = useState(false);
    const loadOptions = (inputValue, callback) => {
        if (inputValue.length > 2) {
            return api.searchOwners({q: inputValue, company})
                .then(response => response.data.data)
                .catch(error => {
                    console.log(error)
                });
        }

        return new Promise(resolve => resolve([]));
    };
    const getOptionLabel = option => `${option.Prenume} ${option.Nume} (${option.Email})`;
    const getOptionValue = option => option.id;

    return (<AsyncSelect
        styles={{
            control: (provided, state) => (isInvalid ? {
                ...provided, borderColor: 'red',
            } : provided)
        }}
        placeholder={`Please enter at least 3 characters...`}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        loadOptions={loadOptions}
        onChange={onChange}
        onBlur={onBlur}
        value={value}/>);
}
